import { useContext, useState, useEffect } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import { AppSpan, AppText, CustomContainer, ScreenTitle } from "src/style"
import { AppCenterPopupPlusD3, Portal } from "src/component"

export const ChatD3: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {userInfo: {profileInfo}}} = useContext(UserContext)
    const [chatHeight, setChatHeight] = useState('')
    const [ebanqoUrl, setEbanqoUrl] = useState('')

    useEffect(() => {
        let width1150 = window.matchMedia('(max-width: 1150px)').matches
        let width900 = window.matchMedia('(max-width: 900px)').matches
        let width600 = window.matchMedia('(max-width: 600px)').matches

        let height = width1150 ? '92.5%' : width900 ? '93.5%' : width600 ? '94%' : '100%'
        setChatHeight(height)
    }, [window])

    useEffect(() => {
        handleGetEbanqoUrl()
    }, [])

    async function handleGetEbanqoUrl () {
        const response = await API.getEbanqoSupport()
        setEbanqoUrl(response)
    }

    return (
        <Portal>
            <AppCenterPopupPlusD3
                title='Chats' 
                height='65' overflow='hidden'
                contentHeight='65' zIndex='6'
                maxHeight='89' outerViewHeight='70' 
                outerViewMaxHeight='70' outerViewMaxHeightUnit='vh'
                close={close} 
            >
                <CustomContainer >
                    <ScreenTitle 
                        textSize="2" fontWeight="600"
                        color="#211121" bottomMargin="2.5"
                        className="module-row-title"
                    >
                        Chats
                    </ScreenTitle>
                </CustomContainer>
                { ebanqoUrl === null ?
                    <CustomContainer
                        bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                        shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                        padding='2' topPadding='1' bottomPadding='1'
                        topMargin='2.5'
                    >
                        <AppText color='#0A756F' fontWeight="600">Service unavailable</AppText>
                        <AppSpan textSize='1.2' color='#0A756F'>
                            This service is currently unavailable, kindly reach out to customer support.
                        </AppSpan>
                    </CustomContainer>
                    :
                    <CustomContainer 
                        height="100" hUnit="%"
                    >
                        <iframe 
                            //src={`https://webchat.ebanqo.io/${institutionData?.alias}/?fullname=Internet%20Banking&email=${profileInfo?.emailAddress}&form_id=email&source=appchat&os=android`}
                            src={ebanqoUrl}
                            width='100%' height='100%'
                            style={{border: 'none'}}
                        /> 
                    </CustomContainer>
                }
            </AppCenterPopupPlusD3>
        </Portal>
    )
} 